import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonLinkComponent } from "./sidebar-button-link.component";

@Component({
    selector: "sidebar-history",
    imports: [],
    templateUrl: "./sidebar-button-link.component.html"
})
export class SidebarHistoryButtonComponent extends SidebarButtonLinkComponent {
    public constructor() { super("History", SvgIcon.Clock, "/history", false); }
}